import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import {setIsMobileDevice} from "@/redux/dataSlice";

const useMobileDevice = () => {
    const dispatch = useDispatch() ;
    
    useEffect(() => {
        const handleResize = () => {
          const { innerWidth, innerHeight } = window;
          if (innerWidth <= 768 && innerHeight <= 1024) {
            dispatch(setIsMobileDevice(true));
          } else {
            dispatch(setIsMobileDevice(false));
          }
        };
      
        handleResize();
        window.addEventListener('resize', handleResize);
      
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, [dispatch]);
}

export default useMobileDevice ;
